import { LoanStatusType, LoanStatusOptions } from '../LoanConstants';

export const getStatusTypeName = (typeId: LoanStatusType) => {
    const item = LoanStatusOptions.find((a) => {
        return a.id === typeId;
    });
    return item?.name ?? '';
};
